<template>
  <!-- Keyed by the notice, so a record created while the last one is still on screen starts its own
       time. Lifted above the save bar pinned to the bottom of the page, which is where the next click
       goes. -->
  <v-snackbar
    v-if="notice"
    :key="notice.id"
    v-model="open"
    :timeout="6000"
    location="bottom"
    style="margin-bottom: 88px"
  >
    <!-- The name as a slot, not a parameter: vue-i18n escapes parameters, and "C25/30" would come out
         as "C25&#x2F;30". -->
    <i18n-t keypath="general.create_series.created" tag="span">
      <template #name>{{ notice.name }}</template>
    </i18n-t>
    <template #actions>
      <v-btn variant="text" class="text-none" @click="openRecord">{{ $t("general.actions.open") }}</v-btn>
      <v-btn icon="mdi-close" variant="text" size="small" :aria-label="$t('general.close')" @click="open = false" />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
/**
 * Names the record "Speichern & neu" or "Speichern & kopieren" just created, with the way to its page.
 * Mounted once in App.vue: the create view it belongs to is remounted for the next form. Goes when the
 * page is left. See docs/navigation.md.
 */
import { ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import { createSeriesNotice as notice } from "@/composables/useCreateSeries"

const route = useRoute()
const router = useRouter()
const open = ref(false)

watch(notice, next => (open.value = Boolean(next)))
watch(
  () => route.path,
  () => (open.value = false)
)

function openRecord() {
  open.value = false
  if (notice.value) router.push(notice.value.to)
}
</script>
